import { type FormEvent, useState } from 'react';
import { useAuth } from '../auth';

export function Login() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await login(password);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Connexion impossible');
      setPassword('');
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="login">
      <form className="login__form" onSubmit={onSubmit}>
        <h1 className="login__title">Ergo Calendar</h1>
        <label className="login__label" htmlFor="password">
          Mot de passe
        </label>
        <input
          id="password"
          className="login__input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />
        {error && (
          <p className="login__error" role="alert">
            {error}
          </p>
        )}
        <button className="login__submit" type="submit" disabled={pending || password === ''}>
          {pending ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </main>
  );
}
